<template>
  <v-card class="mr-3 ml-3 mb-3">
<!--    <v-card-title class="headline">-->
<!--&lt;!&ndash;      <span class="mr-3">Неудачные попытки войти</span>&ndash;&gt;-->
<!--      <v-btn-->
<!--          color="green"-->
<!--          dark-->
<!--          @click="periodDialog = true"-->
<!--      >-->
<!--        <span>Выбрать период</span>-->
<!--      </v-btn>-->
<!--      <v-spacer></v-spacer>-->
<!--      <v-text-field-->
<!--          v-if="logs"-->
<!--          v-model="search"-->
<!--          append-icon="mdi-magnify"-->
<!--          label="Поиск"-->
<!--          single-line-->
<!--          hide-details-->
<!--      ></v-text-field>-->
<!--    </v-card-title>-->
    <v-card-title class="headline justify-space-between">
      <div>
        <v-btn
            color="green"
            dark
            @click="periodDialog = true"
        >
          <span>Выбрать период</span>
        </v-btn>
      </div>

      <div>
        <v-text-field
            v-if="$store.getters.dealers"
            v-model="search"
            append-icon="mdi-magnify"
            label="Поиск"
            single-line
            hide-details
            class="pt-0"
        ></v-text-field>
      </div>
    </v-card-title>

    <v-data-table class="mb-3 mx-3"
                  :search="search"
                  :headers="headers"
                  :items="logsFiltered"
                  sort-by="id"
                  sort-desc
                  no-data-text="Пусто"
                  no-results-text="Результатов нет"
                  hide-default-footer
                  :loading="tableLoading"
                  loading-text="Загрузка"
                  :custom-sort="customSort"
                  :items-per-page="10"
    >
      <template v-slot:item.datetime="{ item }">
        {{ new Date(item.datetime).toLocaleDateString() + ' ' + new Date(item.datetime).toLocaleTimeString() }}
      </template>
      <template v-slot:item.ipInfo="{ item }">
        <span v-html="item.ipInfo"></span>
      </template>
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"/>
      </template>
    </v-data-table>

    <v-dialog v-model="periodDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Выбрать период построения отчета</span>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="d-flex justify-space-between flex-wrap">
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setTodayFilter"
                >Сегодня
                </v-btn>
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setWeekFilter"
                >Неделя
                </v-btn>
                <v-btn class="mb-4"
                       color="green"
                       dark
                       @click="setMonthFilter"
                >Месяц
                </v-btn>
                <v-btn class="mb-4"
                       color="primary"
                       dark
                       @click="setNoFilter"
                >Всё время
                </v-btn>
              </div>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dateFromFormatted"
                      label="Начало периода"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateFromFormatted)"
                      v-on="on"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateFrom"
                               no-title
                               @input="dateFromMenu = false"
                               :max="getIsoDate(new Date())"
                               :first-day-of-week="1"
                               locale="ru-RU"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" class="py-0">
              <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="dateToFormatted"
                      label="Конец периода"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      @blur="date = parseDate(dateToFormatted)"
                      v-on="on"
                      readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="dateTo"
                               no-title
                               @input="dateToMenu = false"
                               :max="getIsoDate(new Date())"
                               :first-day-of-week="1"
                               locale="ru-RU"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="filterLogs">Применить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from "@/axios/api";

export default {
  data() {
    return {
      periodDialog: false,

      dateFromMenu: false,
      dateFrom: null,
      dateFromFormatted: '',

      dateToFormatted: '',
      dateTo: null,
      dateToMenu: false,

      tableLoading: true,
      search: '',
      logs: [],
      logsFiltered: [],
      headers: [
        {
          text: '#',
          align: 'start',
          value: 'id',
        },
        {
          text: 'Email',
          align: 'start',
          value: 'email',
        },
        {
          text: 'IP',
          align: 'start',
          value: 'ipInfo',
        },
        {
          text: 'Дата/Время',
          align: 'start',
          value: 'datetime',
        },
        {
          text: 'Источник',
          align: 'center',
          value: 'source',
        },
      ],
    }
  },
  watch: {
    dateFrom() {
      this.dateFromFormatted = this.formatDate(this.dateFrom);
    },
    dateTo() {
      this.dateToFormatted = this.formatDate(this.dateTo);
    },
    dateFromFormatted() {
      this.dateFrom = this.parseDate(this.dateFromFormatted);
    },
    dateToFormatted() {
      this.dateTo = this.parseDate(this.dateToFormatted);
    },
  },
  methods: {
    customSort(items, index, isDesc) {
      if (index[0] === "datetime") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.datetime) > new Date(b.datetime) ? 1 : -1;
          } else {
            return new Date(a.datetime) > new Date(b.datetime) ? -1 : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    setTodayFilter() {
      this.dateFrom = this.getIsoDate(new Date());
      this.dateTo = this.getIsoDate(new Date());
    },
    setWeekFilter() {
      this.dateFrom = this.getIsoDate(new Date(new Date().setDate(new Date().getDate() - 7)));
      this.dateTo = this.getIsoDate(new Date());
    },
    setMonthFilter() {
      this.dateFrom = this.getIsoDate(new Date(new Date().setMonth(new Date().getMonth() - 1)));
      this.dateTo = this.getIsoDate(new Date());
    },
    setNoFilter() {
      this.dateFrom = this.getIsoDate(new Date(0));
      this.dateTo = this.getIsoDate(new Date());
    },
    filterLogs() {
      this.periodDialog = false;
      let tempDateFrom = new Date(this.dateFrom.split('-')[0], parseInt(this.dateFrom.split('-')[1]) - 1, this.dateFrom.split('-')[2]);
      let tempDateTo = new Date(this.dateTo.split('-')[0], parseInt(this.dateTo.split('-')[1]) - 1, this.dateTo.split('-')[2], 23, 59, 59);

      this.logsFiltered = this.logs.filter(log => {
        let tempDate = new Date(log.datetime);
        return tempDate >= tempDateFrom && tempDate <= tempDateTo;
      });
    },
    getIsoDate(date) {
      return date.toISOString().substr(0, 10);
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    editLicense(license) {
      this.$router.push('/licenses/' + license.id)
    },
    async getLogs() {
      await API.get('reports/users/errors')
          .then((response) => {
            console.log(response.data);
            this.logs = response.data.logs;
            this.filterLogs();
          })
          .catch((error) => {
            console.log(error);
          });
    },
  },
  activated() {
    this.$store.commit('setCrumbs', [
      {text: 'main', disabled: false, to: '/', exact: true},
      {text: 'reports', disabled: true},
      {text: 'users', disabled: true},
      {text: 'errors', disabled: true},
    ]);
    this.getLogs().then(() => {this.tableLoading = false});
  },
  created() {
    this.setWeekFilter();
  }
}
</script>

<style>
</style>
